// components/GlobalLoadingOverlay.tsx
import React from "react";
import { Backdrop, Box, CircularProgress } from "@mui/material";
import SpiderLogo from "./SpiderLogo";
import { useSession } from "../context/SessionContext";

const GlobalLoadingOverlay: React.FC = () => {
  const { isLoading } = useSession();

  const SIZE = 300; // 🔥 Bigger

  return (
    <Backdrop
      open={!!isLoading}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
        backdropFilter: "blur(6px)",
        backgroundColor: "rgba(0,0,0,0.75)", // darker cinematic feel
      }}
    >
      <Box sx={{ position: "relative", width: SIZE, height: SIZE }}>
        {/* Center Spider */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "grid",
            placeItems: "center",
            transform: "scale(4.0)", // make spider slightly bigger too
          }}
        >
          <SpiderLogo />
        </Box>

        {/* Red Ring */}
        <CircularProgress
          size={SIZE}
          thickness={4}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            color: "#d32f2f", // 🔴 red
            filter: "drop-shadow(0 0 8px rgba(211,47,47,0.6))", // subtle glow
          }}
        />
      </Box>
    </Backdrop>
  );
};

export default GlobalLoadingOverlay;